/* eslint-disable */
import React, { useState } from 'react';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Button from 'src/onboarding/components/ui/button/Button';
import { MultiImageSelect } from 'src/onboarding/components/ui/multi-image-select/MultiImageSelect';
import { ImageOption } from 'src/onboarding/components/ui/multi-image-select/ImageOption';
import { images } from 'src/onboarding/constants/images';

function Page() {
  const chooseLunch = useStore((state) => state.chooseLunch);
  const setChooseLunch = useStore((state) => state.setChooseLunch);
  const [next, setNext] = useState(chooseLunch.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setChooseLunch(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.chooseLunch.title')}</Title>
        <Text className='description' size='m' medium style={{ padding: '0 35px' }}>
          {t('onboarding.chooseLunch.subTitle')}
        </Text>
      </div>

      <div className={'cards'} style={{ marginBottom: 70 }}>
        <MultiImageSelect
        onChange={handleChange}
        defaultValue={chooseLunch}
      >
        <ImageOption
          value="Grilled chicken breast with bulgur and zucchini"
          image={images.lunch43}
          label={t('onboarding.chooseLunch.options.chicken')}
        />
        
        <ImageOption 
          value="Beef quesadilla"
          image={images.lunch45}
          label={t('onboarding.chooseLunch.options.beef')}
        />
        
        <ImageOption 
          value="Pasta with tuna and tomatoes"
          image={images.lunch50}
          label={t('onboarding.chooseLunch.options.pasta')}
        />
        
        <ImageOption 
          value="Stuffed eggplants"
          image={images.lunch51}
          label={t('onboarding.chooseLunch.options.eggplants')}
        />
        <ImageOption 
          value="Rice with shrimp"
          image={images.lunch54}
          label={t('onboarding.chooseLunch.options.rice')}
        />
        <ImageOption 
          value="Cutlet with cheddar cheese and bulgur"
          image={images.lunch57}
          label={t('onboarding.chooseLunch.options.cutlet')}
        />
      </MultiImageSelect>
      <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.eatingHabits.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'choose-lunch',
              answer: chooseLunch.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
